import React, { useContext, useRef } from "react";
import "./Header.css";
import theme from "../../utils/theme";
import search1 from "../../assets/search1.svg";
import {
  Box,
  Button,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useHistory } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SliderModal from "./SliderModal";
import { variableContext } from "../../context/VariableContex";
import locations from "../../assets/locations.svg";
import category2 from "../../assets/category2.svg";
import blue from "../../assets/blue.png";
import ShareIcon from "@mui/icons-material/Share";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import ViewListIcon from "@mui/icons-material/ViewList";

const Header = () => {
  const history = useHistory();
  const { locationData, setLocationFilter, layoutMode, setLayoutMode } = useContext(variableContext);

  // Layout 1 = "grid" (switch LEFT)  |  Layout 2 = "list" (switch RIGHT)
  // See LAYOUT_1 / LAYOUT_2 constants in src/context/VariableContex.js
  const isGrid = layoutMode === "grid"; // true  → Layout 1 is active
  const toggleLayout = () => setLayoutMode(isGrid ? "list" : "grid"); // toggles between Layout 1 ↔ Layout 2
  const isMobile = useMediaQuery("(max-width:600px)");
  // LAYOUT_1 (grid): gradient applied via CSS (.header[data-layout="grid"]) — inline style cleared.
  // LAYOUT_2 (list): gradient applied via CSS (.header[data-layout="list"]) — inline style cleared.
  const headerBg = undefined;

  const mobileSearchRef = useRef(null);
  const desktopSearchRef = useRef(null);

  const handleLocContainerClick = () => {
    history.push("/location-search");
  };

  const handleCatContainerClick = () => {
    history.push("/subcategory-search");
  };

  const handleMobileSearchClick = () => {
    mobileSearchRef.current?.focus();
  };

  const handleDesktopSearchClick = () => {
    desktopSearchRef.current?.focus();
  };

  const handleShare = async () => {
    try {
      await navigator.share({
        url: window.location.href,
      });
    } catch (error) { }
  };

  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, onError);
    }
  }

  function onError(error) {
    if (error) {
      // setOpenLocation(true);
    }
  }

  function showPosition(position) {
    setLocationFilter('latitude', position.coords.latitude);
    setLocationFilter('longitude', position.coords.longitude);
  }

  return (
    <div
      className="header"
      data-layout={isGrid ? "grid" : "list"}
      style={{ backgroundColor: headerBg }}
    >
      <div className="container">

        {/* ── MOBILE HEADER (max-width: 600px) ── */}
        <div className="header-mobile">
          {/* White pill — same style as desktop */}
          <div className="header-mobile-pill">
            {/* Row 1: Logo + Location + Category + Search + Switch + Share */}
            <div className="header-mobile-row1">
              <img src={blue} alt="Master Click" className="header-mobile-logo" />

              {/* Location */}
              <div
                className="header-mobile-loc"
                onClick={handleLocContainerClick}
                style={{ cursor: "pointer", position: "relative" }}
              >
                <img src={locations} alt="" style={{ width: 12, flexShrink: 0, pointerEvents: "none" }} />
                <span style={{ fontSize: "11px", fontWeight: "500", color: "rgba(33,130,177,1)", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", pointerEvents: "none", paddingLeft: 2 }}>
                  {locationData?.locationName || "Location"}
                </span>
                <ArrowDropDownIcon style={{ fontSize: 16, color: "rgba(33,130,177,1)", flexShrink: 0, pointerEvents: "none" }} />
                <span
                  className="loc-gps-btn"
                  onClick={(e) => { e.stopPropagation(); getLocation(); }}
                  style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer", padding: "0 2px", zIndex: 1 }}
                >
                  <GpsFixedIcon sx={{ color: "rgba(33,130,177,1)", fontSize: "14px", pointerEvents: "none" }} />
                </span>
              </div>

              {/* Category */}
              <div className="header-mobile-cat" onClick={handleCatContainerClick} style={{ cursor: "pointer" }}>
                <img src={category2} alt="" style={{ width: 12, flexShrink: 0, pointerEvents: "none" }} />
                <span style={{ fontSize: "11px", fontWeight: "500", color: "rgba(33,130,177,1)", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", pointerEvents: "none", paddingLeft: 2 }}>
                  Category
                </span>
                <ArrowDropDownIcon style={{ fontSize: 14, color: "rgba(33,130,177,1)", flexShrink: 0, pointerEvents: "none" }} />
              </div>

              {/* Search */}
              <div className="header-mobile-search" onClick={handleMobileSearchClick} style={{ cursor: "text" }}>
                <input
                  ref={mobileSearchRef}
                  className="header-mobile-search-input"
                  type="text"
                  placeholder="Search"
                  onKeyDown={(e) => { if (e.key === "Enter") history.push("/searchscreen"); }}
                />
                <button
                  className="header-mobile-search-btn"
                  onClick={(e) => { e.stopPropagation(); history.push("/searchscreen"); }}
                >
                  Search
                </button>
              </div>
            </div>

            {/* Row 2: Distance slider + Layout Switch + Share */}
            <div className="header-mobile-row2">
              <div className="header-mobile-row2-slider">
                <SliderModal />
              </div>
              {/* Layout Switch — premium toggle */}
              <div
                className={`header-layout-toggle ${isGrid ? "is-grid" : "is-list"}`}
                onClick={toggleLayout}
                title={isGrid ? "Switch to List View" : "Switch to Grid View"}
              >
                <div className="header-layout-toggle-thumb">
                  {isGrid
                    ? <ViewModuleIcon sx={{ fontSize: "13px" }} />
                    : <ViewListIcon sx={{ fontSize: "13px" }} />}
                </div>
              </div>
              {/* Share */}
              <div className="header-mobile-icon-btn" onClick={handleShare}>
                <ShareIcon sx={{ color: "rgba(33,130,177,1)", fontSize: "16px" }} />
              </div>
            </div>
          </div>
        </div>

        {/* ── DESKTOP HEADER (min-width: 1024px via CSS) ── */}
        <div className="header-desktop">
          <div className="header-white-bar">
            <div className="logo-icon-body">
              <img src={blue} alt="Master Click" width="150px" height={"100%"} />
            </div>

            <div className="dropdown-search-body">
              <Grid container spacing={2}>
                <Grid item xs={5}>
                  <div className="loc-dropdown" style={{ paddingLeft: "6px", cursor: "pointer" }} onClick={handleLocContainerClick}>
                    <img src={locations} alt="" style={{ pointerEvents: "none" }} />
                    <span style={{ fontSize: "16px", fontWeight: "500", color: "rgba(33,130,177,1)", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", pointerEvents: "none", paddingLeft: 6 }}>
                      {locationData?.locationName || "Location"}
                    </span>
                    <ArrowDropDownIcon style={{ fontSize: 22, color: "rgba(33,130,177,1)", flexShrink: 0, pointerEvents: "none" }} />
                    <Button sx={{ minWidth: "0px", padding: "0px", flexShrink: 0, zIndex: 1 }} onClick={(e) => { e.stopPropagation(); getLocation(); }}>
                      <GpsFixedIcon sx={{ color: "rgba(33, 130, 177, 1)", fontSize: "20px", marginRight: "8px", pointerEvents: "none" }} />
                    </Button>
                  </div>
                </Grid>
                <Grid item xs={5}>
                  <div className="radius-dropdown" onClick={handleCatContainerClick} style={{ cursor: "pointer" }}>
                    <img src={category2} alt="" style={{ pointerEvents: "none" }} />
                    <span style={{ fontSize: "16px", fontWeight: "500", color: "rgba(33,130,177,1)", flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", pointerEvents: "none", paddingLeft: 6 }}>
                      Category
                    </span>
                    <ArrowDropDownIcon style={{ fontSize: 22, color: "rgba(33,130,177,1)", flexShrink: 0, pointerEvents: "none" }} />
                  </div>
                </Grid>
                <Grid item xs={2} sx={{ display: "flex", justifyContent: "end" }}>
                  <Box className="search-box">
                    <img onClick={() => history.push("/searchscreen")} src={search1} alt="" />
                  </Box>
                </Grid>
              </Grid>
            </div>

            <div className="header-search-wrap" onClick={handleDesktopSearchClick} style={{ cursor: "text" }}>
              <input
                ref={desktopSearchRef}
                className="header-search-input"
                type="text"
                placeholder="Search"
                onKeyDown={(e) => { if (e.key === "Enter") history.push("/searchscreen"); }}
              />
              <button className="header-search-btn" onClick={(e) => { e.stopPropagation(); history.push("/searchscreen"); }}>
                Search
              </button>
            </div>

            <div className="slider-row"><SliderModal /></div>

            {/* Layout Switch — premium toggle */}
            <div
              className={`header-layout-toggle ${isGrid ? "is-grid" : "is-list"}`}
              onClick={toggleLayout}
              title={isGrid ? "Switch to List View" : "Switch to Grid View"}
            >
              <div className="header-layout-toggle-thumb">
                {isGrid
                  ? <ViewModuleIcon sx={{ fontSize: "14px" }} />
                  : <ViewListIcon sx={{ fontSize: "14px" }} />}
              </div>
            </div>

            <div className="header-share-desktop" onClick={handleShare}>
              <ShareIcon sx={{ color: "rgba(33, 130, 177, 1)", fontSize: "18px" }} />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Header;
